export type SfAccountMini = {
  Id?: string
  Name?: string
}

export type SfAccount = SfAccountMini & {
  BillingStreet?: string
  BillingCity?: string
  Type: string
  Parent?: {
    Name: string
  }
  LastActivityDate?: string
  BillingAddress?: {
    city: string
    country: string
    postalCode: string
    state: string
    street: string
  }
}

export enum EventAction {
  CREATE = 'create',
  PATCH = 'patch',
  DELETE = 'delete',
}

export enum SfEventColors {
  PLANNED_NO_PITCHER_EVENT = '#2196F3',
  PAST = '#F44336',
  SUBMITTED = '#4CAF50',
  SUBMITTED_FOR_LATER = '#FFEB3B',
  TIME_OFF_TERRITORY = '#757575',
  PLANNED = PLANNED_NO_PITCHER_EVENT,
}

export enum SfEventColorsLight {
  PLANNED_NO_PITCHER_EVENT = '#E3F2FD',
  PAST = '#FFEBEE',
  SUBMITTED = '#E8F5E9',
  SUBMITTED_FOR_LATER = '#FFFDE7',
  TIME_OFF_TERRITORY = '#E0E0E0',
  PLANNED = PLANNED_NO_PITCHER_EVENT,
}

export type SfEvent = {
  Id?: string
  Name?: string
  Account?: {
    Name?: string
  }
  AccountId?: string
  Description?: string
  DurationInMinutes?: string
  OwnerId?: string
  Subject?: string
  StartDateTime?: string
  EndDateTime?: string
  WhatId?: string
  WhatCount?: number
  WhoCount?: number
  WhoId?: string
  Type?: string
  EventWhoIds?: string[]
  IsAllDayEvent?: boolean
  is_executed_condition?: string
}

export type SfEventExtended = SfEvent & {
  contactName?: string
  accountName?: string
  contacts?: any
  extraContacts?: number
}

export type SfEventRelation = {
  AccountId?: SfAccount['Id']
  EventId?: SfEvent['Id']
  IsDeleted?: boolean
  IsInvitee?: boolean
  IsParent?: boolean
  IsWhat?: boolean
  RelationId?: string
  RespondedDate?: string
  Response?: string
  Status?: string
}

export type SfUser = {
  Id: string
  Address?: string
  Email?: string
  FirstName?: string
  LastName?: string
  Name?: string
}

export type SfContact = {
  Id: string
  Name?: string
  AccountId?: SfAccount['Id']
  Email?: string
  MailingAddress?: string
  Phone?: string
}

export interface SfContactBasic {
  AccountId: string
  Email: string
  Id: string
  LastViewedDate: string | null
  MailingAddress: string | null
  Name: string
  Phone: string | null
  attributes: {
    type: string
    url: string
  }
  callId?: string
  PersonAccountId?: string
  AccountName?: string
  Account?: any
}

export type EventsSfList = {
  done?: boolean
  records?: Array<object>
  totalSize?: number
}

export type EventsFetchRequest = {
  end_at__lt?: string
  start_at__gt?: string
  userId?: string
  external_objects__external_object_id?: SfEvent['Id']
}

export type CreateSfEventParams = {
  end_at?: string
  start_at?: string
  description?: string
  duration?: string
}
